import { useState, createContext, useContext } from "react";

const StepContext = createContext();
export const useStep = () => useContext(StepContext);

export const StepProvider = ({ children }) => {
  const [stepData, setStepData] = useState({}); // store page-specific inputs

  return (
    <StepContext.Provider value={{ stepData, setStepData }}>
      {children}
    </StepContext.Provider>
  );
};